/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModWorkflow: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9 15C9.801 15 10.555 14.688 11.121 14.121L12 13.242V15C12 15.553 11.552 16 11 16H1C0.448 16 0 15.553 0 15V2C0 1.448 0.448 1 1 1H2C2 0.448 2.448 0 3 0H9C9.552 0 10 0.448 10 1H11C11.552 1 12 1.448 12 2V4.758L9 7.757L8.121 6.879C7.555 6.312 6.801 6 6 6C5.199 6 4.445 6.312 3.879 6.879C3.313 7.445 3 8.199 3 9C3 9.801 3.313 10.555 3.879 11.121L6.879 14.121C7.445 14.688 8.199 15 9 15ZM9 2H3V1H9V2Z'
			/>
			<path d='M5.293 9.707L8.293 12.707C8.488 12.902 8.744 13 9 13C9.256 13 9.512 12.902 9.707 12.707L15.707 6.707C16.098 6.316 16.098 5.684 15.707 5.293C15.316 4.902 14.684 4.902 14.293 5.293L9 10.586L6.707 8.293C6.316 7.902 5.684 7.902 5.293 8.293C4.902 8.684 4.902 9.316 5.293 9.707Z' />
		</Svg>
	);
};

export { ModWorkflow };
